export default __webpack_public_path__ + "img/5536abe451cbd75b57543337388718ac.svg";